import React from 'react';
import './AnimatedIntro.scss';
import { Typography, Icon } from '@design-system';
import { motion } from 'framer-motion';
import { GrFormCheckmark } from 'react-icons/gr';

export type AnimatedIntroProps = {
    steps: string[];
};

export const AnimatedIntro: React.FC<AnimatedIntroProps> = ({ steps }) => {
    return (
        <div className="animated-intro">
            {steps.map((step, index) => (
                <motion.div
                    key={index}
                    className="animated-intro-step"
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{
                        duration: 0.2,
                        delay: index * 0.2
                    }}
                >
                    <Typography intrinsic="h3" className="step-number">
                        {index === steps.length - 1 ? <Icon icon={<GrFormCheckmark />} size={28} color="green" /> : index + 1}
                    </Typography>
                    <Typography intrinsic="h4">{step}</Typography>
                </motion.div>
            ))}
        </div>
    );
};
